module.exports = __webpack_public_path__ + "static/media/ng.f6a23478.svg";